<template>
  <div class="passwordPoliciesContainer">
        <b-field class="input-wrapper" custom-class="is-label-input" label="Contraseña nueva">
            <b-input
                @input="handleNewPassword($event)"
                :value="newPassword"
                class="new-password"
                type="password"
                password-reveal
            />
            <p class="is-grey">Tu contraseña debe tener:</p>
            <div class="checkboxesContainer">
                <b-checkbox v-model="minChars" disabled>Mínimo 8 caracteres </b-checkbox>
                <b-checkbox v-model="atLeastMinusMayus" disabled>Al menos una mayúscula y una minúscula</b-checkbox>
                <b-checkbox v-model="atLeastNumber" disabled>Al menos un número</b-checkbox>
                <b-checkbox v-model="atLeastSpecial" disabled>Al menos un caracter especial, ejemplo: !-_$.%/()>¿?+ {}[]@</b-checkbox>
            </div>
        </b-field>
        <b-field :type="typeInputRenewPassword" class="input-wrapper" custom-class="is-label-input" label="Repetir contraseña nueva">
            <b-input
                @input="handleReNewPassword($event)"
                :value="reNewPassword"
                type="password"
                :disabled="completeCheckboxes()"
                password-reveal
            />
            <p class="errorLabel" v-show="showReNewPasswordError">las contraseñas no coinciden</p>
        </b-field>
  </div>
</template>

<script>
import { atLeastOneNumber, atLeastEightCharacters, atLeastOneMinusAndMayus, atLeastOneSpecialCharacter } from '../utils/validations';
export default {
    data() {
        return {
            newPassword: "",
            reNewPassword: "",
            minChars: false,
            atLeastMinusMayus: false,
            atLeastNumber: false,
            atLeastSpecial: false,
            passwordsMatch: false,
            showReNewPasswordError: false,
            typeInputRenewPassword: ""
        }
    },

    methods: {
       handleNewPassword(value) {
           this.newPassword = value
           this.validator()
           this.completeCheckboxes()
           this.passwordsMatch = !!(this.reNewPassword == this.newPassword)
           const checkboxesComplete = this.completeCheckboxes()
           this.$emit('changeNewPassword', this.passwordsMatch)
           this.$emit('isCheckboxesComplete', !checkboxesComplete)
           this.$emit('newPasswordValue', this.newPassword)
       },

       handleReNewPassword(value) {
           this.reNewPassword = value
           this.passwordsMatch = !!(this.reNewPassword == this.newPassword)
           this.showReNewPasswordError = !this.passwordsMatch
           this.passwordsMatch ? this.typeInputRenewPassword = "" : this.typeInputRenewPassword = "is-danger"
           this.$emit('changeReNewPassword', this.passwordsMatch);
           this.$emit('getReNewPassword', this.reNewPassword);
       },

       validator() {
           this.atLeastNumber = atLeastOneNumber(this.newPassword);
           this.minChars = atLeastEightCharacters(this.newPassword);
           this.atLeastMinusMayus = atLeastOneMinusAndMayus(this.newPassword);
           this.atLeastSpecial = atLeastOneSpecialCharacter(this.newPassword);
       },

        completeCheckboxes() {
            return !(this.minChars && this.atLeastMinusMayus && this.atLeastNumber && this.atLeastSpecial);
        }
    }
}
</script>

<style lang="scss">
@import '../assets/scss/variables.scss';
.passwordPoliciesContainer {
    margin-bottom: 32px;
}
.passwordPoliciesContainer {
    margin-bottom: 40px;
}
.b-checkbox.checkbox[disabled] {
    opacity: 1;
}
.checkboxesContainer {
    margin-bottom: 20px;
}
.input-wrapper {
    flex-direction: column;
}
.errorLabel {
    color: $primary;
}
.is-danger.input {
    border-color: $primary;
    border-radius: 4px !important;
}
.is-danger.input:focus {
    box-shadow: 0 0 0 0.125em rgba(255,109,70,0.25) !important;
    -webkit-box-shadow: 0 0 0 0.125em rgba(255,109,70,0.25) !important;
}
.input[disabled] {
    border-radius: 4px !important;
}
.input {
    border-radius: 4px !important;
}
.is-grey {
    font-weight: bold;
    color: $bold-grey;
    margin-bottom: 4px;
}
.b-checkbox.checkbox .control-label {
    padding-left: 16px;
}
.fieldContainer {
    margin-bottom: 32px !important;
}
.new-password {
    margin-bottom: 4px;
}

.b-checkbox.checkbox input[type=checkbox]:checked + .check {
    background: #00cec5 url("../assets/images/checkmark-checkbox.png") no-repeat center center;
    border-color: #00cec5;
}
</style>